import { useCvLanguage } from '../cvLanguage';
import { useRef, useState } from 'react';
export function useCvPdf(cvData, documentLanguage) {
  const { language } = useCvLanguage();
  const [downloading, setDownloading] = useState(false),
    [error, setError] = useState('');
  const busy = useRef(false);
  const download = async () => {
    if (busy.current) return;
    busy.current = true;
    setDownloading(true);
    setError('');
    let url;
    try {
      const [{
        pdf
      }, {
        default: Document
      }, {
        default: React
      }] = await Promise.all([import('@react-pdf/renderer'), import('../../CurriculumPDFDocument'), import('react')]);
      const blob = await pdf(React.createElement(Document, {
        data: cvData,
        language: documentLanguage || language
      })).toBlob();
      url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `${(cvData.personalInfo?.name || 'Curriculum').trim().replace(/[^\p{L}\p{N}_-]+/gu, '_')}_CV.pdf`;
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch {
      setError('No se pudo generar el PDF. Vuelve a intentarlo.');
    } finally {
      if (url) setTimeout(() => URL.revokeObjectURL(url), 1000);
      busy.current = false;
      setDownloading(false);
    }
  };
  return {
    download,
    downloading,
    error
  };
}
